module.exports = __webpack_public_path__ + "static/media/Limitless Pauseibilities - Move - Large.7cb6b47c.jpg";